import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import styles from "./style.module.css";

interface Props {
  show: boolean;
  handleClose: () => void;
  iso: string;
  columns:any[]; // <-- New prop for column names
  selectedColumns: string[]; // <-- New prop for selected columns
  setSelectedColumns:any
}

const SelectColumns = (props: Props) => {

  const handleCheckboxChange = (column: string) => {
    props.setSelectedColumns((prev:any) =>
      prev.includes(column)
        ? prev.filter((col:any) => col !== column)
        : [...prev, column]
    );
  };

  const closePopup = () => {
    props.handleClose();
  };

  return (
    <Modal centered size="sm" show={props.show} onHide={props.handleClose}>
      <Modal.Header className={styles.modHead}>
        <Modal.Title>Select Columns</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.faqContent}>
        <div className={styles.columnList}>
          {props.columns.map((column) => (
            <div key={column.value} className={styles.checkboxItem}>
              <label>
                <input style={{ marginRight: "5px" }}
                  type="checkbox"
                  checked={props.selectedColumns.includes(column)}
                  onChange={() => handleCheckboxChange(column)}
                />
                {column.value}
              </label>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className={styles.modFoter}>
        <button type="button" className={styles.close} onClick={closePopup}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectColumns;
